/**
 * THE PIN KEY.
 *
 * Three pin colours ship with nothing on the globe saying what they mean, so
 * this captions them. It only appears with TWO OR MORE pins down — one dot the
 * player just placed themselves needs no caption.
 *
 * It used to be absolutely positioned in the globe's bottom-left corner at a
 * z-index ABOVE the HUD, which on a phone parked it squarely on top of the BANK
 * button: the most consequential control in the game, captioned over by a
 * legend. It now lives in the HUD's own flow, above the pot line, where it
 * cannot cover anything — and it is laid out as a row of chips rather than a
 * stack, because a horizontal strip costs the globe far less height.
 */

export interface PinKeyRow {
  readonly kind: 'target' | 'you' | 'opponent';
  readonly label: string;
}

export interface PinKeyProps {
  readonly rows: readonly PinKeyRow[];
}

export function PinKey({ rows }: PinKeyProps): React.JSX.Element | null {
  if (rows.length < 2) return null;

  return (
    <ul className="gg-pin-key" aria-label="What the pins mean">
      {rows.map((row) => (
        <li key={row.kind} className="gg-pin-key-row">
          <span className="gg-pin-key-dot" data-kind={row.kind} aria-hidden="true" />
          {row.label}
        </li>
      ))}
    </ul>
  );
}
